import { render, staticRenderFns } from "./PopupPlanInactive.vue?vue&type=template&id=ca0bc8b0"
import script from "./PopupPlanInactive.vue?vue&type=script&lang=js"
export * from "./PopupPlanInactive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports